import { all, takeLatest } from 'redux-saga/effects';
import { otpAuthSaga } from './authSaga';
import { authConstants } from '../actions/constants/authConstants';
import { userConstants } from '../actions/constants/userConstants';
import { userSaga } from './userSaga';
import { commonConstants } from '../actions/constants/commonConstants';
import { commonSaga } from './commonSaga';
import { categorySaga } from './categorySaga';
import { categoryConstants } from '../actions/constants/categoryContansts';
import { querySaga } from './querySaga';
import { queryConstants } from '../actions/constants/queryConstants';
import { leadSaga } from './leadSaga';
import { leadConstants } from '../actions/constants/leadConstants';
import { dashboardSaga } from './dashboardSaga';
import { dashboardConstants } from '../actions/constants/dashboardConstants';
import { enrollmentSaga } from './enrollmentSaga';
import { enrollmentConstants } from '../actions/constants/enrollmentConstants';
import { vehicleConstants } from '../actions/constants/vehicleConstants';
import { vehicleSaga } from './vehicleSaga';
import { batchConstants } from '../actions/constants/batchConstants';
import { batchSaga } from './batchSaga';
import { expenseConstants } from '../actions/constants/expenseConstants';
import { expenseSaga } from './expenseSaga';
import { feeConstants } from '../actions/constants/feeConstants';
import { feeSaga } from './feeSaga';
import { preferenceConstants } from '../actions/constants/preferenceConstants';
import { preferenceSaga } from './preferenceSaga';
import { subscriptionConstants } from '../actions/constants/subscriptionConstants';
import { subscriptionSaga } from './subscriptionSaga';
import { tenantConstants } from '../actions/constants/tenantConstants';
import { tenantSaga } from './tenantSaga';
import { branchConstants } from '../actions/constants/branchConstants';
import { branchSaga } from './branchSaga';
import { trackingConstants } from '../actions/constants/trackingConstants';
import { trackingSaga } from './trackingSaga';
import { reviewSaga } from './reviewSaga';
import { reviewConstants } from '../actions/constants/reviewConstants';

function* rootSaga() {
    yield all([
        //auth Saga
        takeLatest(authConstants.otpLoginRequest, otpAuthSaga.otpLogin),
        takeLatest(authConstants.resendOtpRequest, otpAuthSaga.resendOtp),
        takeLatest(authConstants.otpVerifyRequest, otpAuthSaga.otpVerify),
        takeLatest(authConstants.renewTokenRequest, otpAuthSaga.renewToken),
        takeLatest(authConstants.acceptInvitationRequest, otpAuthSaga.acceptInvitation),
        takeLatest(authConstants.verifyTokenRequest, otpAuthSaga.verifyToken),
        takeLatest(authConstants.registerTenantRequest, otpAuthSaga.registerTenant),
        takeLatest(authConstants.verifyRegistrationRequest, otpAuthSaga.verifyRegistration),
        takeLatest(authConstants.checkTenantExistsRequest, otpAuthSaga.checkTenantExists),
        takeLatest(authConstants.revokeDeviceSessionRequest, otpAuthSaga.revokeDeviceSession),
        takeLatest(authConstants.logoutRequest, otpAuthSaga.logoutSaga),

        //User saga
        takeLatest(userConstants.roleUserRequest, userSaga.getRole),
        takeLatest(userConstants.userCreateRequest, userSaga.createUser),
        takeLatest(userConstants.userListRequest, userSaga.listUsers),
        takeLatest(userConstants.userUpdateRequest, userSaga.updateUser),
        takeLatest(userConstants.userViewRequest, userSaga.viewUser),
        takeLatest(userConstants.getProfileRequest, userSaga.getProfile),
        takeLatest(userConstants.updateProfileRequest, userSaga.updateProfile),
        takeLatest(userConstants.uploadProfileImageRequest, userSaga.uploadProfileImage),
        takeLatest(userConstants.getTermsByTypeRequest, userSaga.getTermsByType),
        takeLatest(userConstants.sendInvitationRequest, userSaga.sendInvitation),

        //category and Service saga
        takeLatest(commonConstants.getServiceRequest, commonSaga.getService),
        takeLatest(categoryConstants.getCategoryRequest, categorySaga.getCategory),
        takeLatest(categoryConstants.categoryCreateRequest, categorySaga.createCategory),
        takeLatest(categoryConstants.getCategoryParamsRequest, categorySaga.getCategoryParams),
        takeLatest(categoryConstants.categoryDeleteRequest, categorySaga.deleteCategory),
        takeLatest(categoryConstants.categoryToggleRequest, categorySaga.toggleCategory),
        takeLatest(categoryConstants.categoryViewRequest, categorySaga.viewCategory),
        takeLatest(commonConstants.getServiceParamsRequest, commonSaga.getServiceParams),
        takeLatest(commonConstants.serviceViewRequest, commonSaga.getServiceView),
        takeLatest(commonConstants.createServiceRequest, commonSaga.createService),
        takeLatest(commonConstants.serviceToggleRequest, commonSaga.toggleService),
        takeLatest(commonConstants.deleteServiceRequest, commonSaga.deleteService),
        takeLatest(commonConstants.fileDeleteRequest, commonSaga.deleteFiles),

        //enrollment saga
        takeLatest(enrollmentConstants.getEnrollmentParamsRequest, enrollmentSaga.getEnrollmentParams),
        takeLatest(enrollmentConstants.createEnrollmentRequest, enrollmentSaga.createEnrollment),
        takeLatest(enrollmentConstants.deleteEnrollmentRequest, enrollmentSaga.deleteEnrollment),
        takeLatest(enrollmentConstants.enrollmentViewRequest, enrollmentSaga.getEnrollmentView),
        takeLatest(enrollmentConstants.enrollmentToggleRequest, enrollmentSaga.toggleEnrollment),
        takeLatest(enrollmentConstants.exportEnrollmentRequest, enrollmentSaga.exportEnrollment),
        takeLatest(enrollmentConstants.assignApplicationRequest, enrollmentSaga.assignApplication),

        //vehicle saga
        takeLatest(vehicleConstants.getVehicleParamsRequest, vehicleSaga.listVehicles),
        takeLatest(vehicleConstants.vehicleCreateRequest, vehicleSaga.createVehicle),
        takeLatest(vehicleConstants.vehicleToggleRequest, vehicleSaga.toggleVehicle),
        takeLatest(vehicleConstants.vehicleDeleteRequest, vehicleSaga.deleteVehicle),
        takeLatest(vehicleConstants.vehicleViewRequest, vehicleSaga.viewVehicle),
        takeLatest(vehicleConstants.vehicleUploadRequest, vehicleSaga.uploadVehicle),

        // trip sheet saga
        takeLatest(vehicleConstants.tripSheetSaveRequest, vehicleSaga.saveTripSheet),
        takeLatest(vehicleConstants.tripSheetListRequest, vehicleSaga.listTripSheets),
        takeLatest(vehicleConstants.tripSheetViewRequest, vehicleSaga.viewTripSheet),
        takeLatest(vehicleConstants.tripSheetDeleteRequest, vehicleSaga.deleteTripSheet),
        takeLatest(vehicleConstants.tripSheetByVehicleRequest, vehicleSaga.listTripSheetsByVehicle),
        takeLatest(vehicleConstants.tripSheetByBatchRequest, vehicleSaga.listTripSheetsByBatch),

        // batch saga
        takeLatest(batchConstants.getBatchRequest, batchSaga.getBatch),
        takeLatest(batchConstants.getBatchParamsRequest, batchSaga.getBatchParams),
        takeLatest(batchConstants.batchCreateRequest, batchSaga.createBatch),
        takeLatest(batchConstants.batchDeleteRequest, batchSaga.deleteBatch),
        takeLatest(batchConstants.batchToggleRequest, batchSaga.toggleBatch),
        takeLatest(batchConstants.getAvailableUsersRequest, batchSaga.getAvailableUsers),
        takeLatest(batchConstants.batchViewRequest, batchSaga.viewBatch),
        takeLatest(batchConstants.getAvailableStudentsRequest, batchSaga.getAvailableStudents),
        takeLatest(batchConstants.attendanceMarkedRequest, batchSaga.markAttendance),
        takeLatest(batchConstants.getBatchHistoryRequest, batchSaga.getBatchHistory),
        takeLatest(batchConstants.getOverallStudentAnalyticsRequest, batchSaga.getOverallStudentAnalytics),
        takeLatest(batchConstants.getSessionAnalyticsRequest, batchSaga.getSessionAnalytics),
        takeLatest(batchConstants.getAvailableStudentsForBatchRequest, batchSaga.getAvailableStudentsForBatch),
        takeLatest(batchConstants.getCalendarDetailsRequest, batchSaga.getCalendarDetails),

        //expense saga
        takeLatest(expenseConstants.getExpenseParamsRequest, expenseSaga.getExpenseParams),
        takeLatest(expenseConstants.createExpenseRequest, expenseSaga.createExpense),
        takeLatest(expenseConstants.deleteExpenseRequest, expenseSaga.deleteExpense),
        takeLatest(expenseConstants.expenseViewRequest, expenseSaga.getExpenseView),

        //fee saga
        takeLatest(feeConstants.getFeeParamsRequest, feeSaga.getFeeParams),
        takeLatest(feeConstants.createFeeRequest, feeSaga.createFee),
        takeLatest(feeConstants.deleteFeeRequest, feeSaga.deleteFee),
        takeLatest(feeConstants.feeViewRequest, feeSaga.getFeeView),
        takeLatest(feeConstants.getStudentFeeSummaryRequest, feeSaga.getStudentFeeSummary),
        takeLatest(feeConstants.getEnrollmentFeeHistoryRequest, feeSaga.getEnrollmentFeeHistory),
        takeLatest(feeConstants.exportFeeRequest, feeSaga.exportFee),

        // query saga
        takeLatest(queryConstants.listQueriesRequest, querySaga.listQueries),
        takeLatest(queryConstants.saveQueryRequest, querySaga.saveQuery),
        takeLatest(queryConstants.viewQueryRequest, querySaga.viewQuery),
        takeLatest(queryConstants.deleteQueryRequest, querySaga.deleteQuery),
        takeLatest(queryConstants.addRemarksRequest, querySaga.addRemarks),

        // lead saga
        takeLatest(leadConstants.listLeadsRequest, leadSaga.listLeads),
        takeLatest(leadConstants.saveLeadRequest, leadSaga.saveLead),
        takeLatest(leadConstants.viewLeadRequest, leadSaga.viewLead),
        takeLatest(leadConstants.updateLeadRequest, leadSaga.updateLead),
        takeLatest(leadConstants.deleteLeadRequest, leadSaga.deleteLead),
        takeLatest(leadConstants.addFollowUpRequest, leadSaga.addFollowUp),

        // dashboard saga
        takeLatest(dashboardConstants.getCommonReportsRequest, dashboardSaga.getCommonReports),
        takeLatest(dashboardConstants.getRevenueReportRequest, dashboardSaga.getRevenueReport),
        takeLatest(dashboardConstants.getStudentReportRequest, dashboardSaga.getStudentReport),
        takeLatest(dashboardConstants.getInstructorReportRequest, dashboardSaga.getInstructorReport),

        // preference saga
        takeLatest(preferenceConstants.getPreferenceRequest, preferenceSaga.getPreference),
        takeLatest(preferenceConstants.getPreferenceByPhoneRequest, preferenceSaga.getPreferenceByPhone),
        takeLatest(preferenceConstants.savePreferenceRequest, preferenceSaga.savePreference),

        // subscription saga
        takeLatest(subscriptionConstants.getSubscriptionPlanRequest, subscriptionSaga.getSubscriptionPlan),
        takeLatest(subscriptionConstants.createSubscriptionRequest, subscriptionSaga.createSubscription),
        takeLatest(subscriptionConstants.getSubscriptionStatusRequest, subscriptionSaga.getSubscriptionStatus),
        takeLatest(subscriptionConstants.getOrderStatusRequest, subscriptionSaga.getOrderStatus),
        takeLatest(subscriptionConstants.syncPlansRequest, subscriptionSaga.syncPlans),
        takeLatest(subscriptionConstants.getAllPlansRequest, subscriptionSaga.getAllPlans),
        takeLatest(subscriptionConstants.getUserSubscriptionStatusRequest, subscriptionSaga.getUserSubscriptionStatus),
        takeLatest(subscriptionConstants.listAdminPlansRequest, subscriptionSaga.listAdminPlans),
        takeLatest(subscriptionConstants.viewAdminPlanRequest, subscriptionSaga.viewAdminPlan),
        takeLatest(subscriptionConstants.saveAdminPlanRequest, subscriptionSaga.saveAdminPlan),
        takeLatest(subscriptionConstants.deleteAdminPlanRequest, subscriptionSaga.deleteAdminPlan),
        takeLatest(subscriptionConstants.getRoutesRequest, subscriptionSaga.getRoutes),
        takeLatest(subscriptionConstants.getSubscriptionSyncStatusRequest, subscriptionSaga.getSubscriptionSyncStatus),
        takeLatest(subscriptionConstants.getInvoiceRequest, subscriptionSaga.getInvoice),
        takeLatest(subscriptionConstants.getAllInvoicesRequest, subscriptionSaga.getAllInvoices),
        takeLatest(subscriptionConstants.getInvoicePDFRequest, subscriptionSaga.getInvoicePDF),
        takeLatest(subscriptionConstants.getOverallInvoicesRequest, subscriptionSaga.getOverallInvoices),

        // tenant saga
        takeLatest(tenantConstants.getTenantListRequest, tenantSaga.getTenantList),
        takeLatest(tenantConstants.getHeaderTenantListRequest, tenantSaga.getHeaderTenantList),
        takeLatest(tenantConstants.tenantSaveRequest, tenantSaga.saveTenant),
        takeLatest(tenantConstants.tenantViewRequest, tenantSaga.viewTenant),
        takeLatest(tenantConstants.getAccessControlRequest, tenantSaga.getAccessControl),
        takeLatest(tenantConstants.saveAccessControlRequest, tenantSaga.saveAccessControl),

        // tenant switch & branch saga
        takeLatest(branchConstants.enableBranchesRequest, branchSaga.enableBranches),
        takeLatest(branchConstants.createBranchRequest, branchSaga.createBranch),
        takeLatest(branchConstants.listBranchesRequest, branchSaga.listBranches),
        takeLatest(branchConstants.switchTenantRequest, branchSaga.switchTenant),

        // instructor history saga
        takeLatest(userConstants.getInstructorHistoryRequest, userSaga.getInstructorHistory),

        // tracking saga
        takeLatest(trackingConstants.listSessionsRequest, trackingSaga.listSessions),
        takeLatest(trackingConstants.viewSessionRequest, trackingSaga.viewSession),
        takeLatest(trackingConstants.getActiveSessionsRequest, trackingSaga.getActiveSessions),
        takeLatest(trackingConstants.getSessionByBatchTodayRequest, trackingSaga.getSessionByBatchToday),
        takeLatest(trackingConstants.historyListRequest, trackingSaga.historyList),
        takeLatest(trackingConstants.viewSessionStudentsRequest, trackingSaga.viewSessionWithStudents),

        // location share saga
        takeLatest(trackingConstants.generateShareTokenRequest, trackingSaga.generateShareToken),
        takeLatest(trackingConstants.disableShareRequest, trackingSaga.disableShare),
        takeLatest(trackingConstants.getShareStatusRequest, trackingSaga.getShareStatus),

        // contact email saga
        takeLatest(commonConstants.contactEmailRequest, commonSaga.sendMail),
        takeLatest(commonConstants.fileUploadUserRequest, commonSaga.fileUploadUser),
        takeLatest(commonConstants.getPrivacyPolicyRequest, commonSaga.getPrivacyPolicy),
        takeLatest(commonConstants.getTermsOfServiceRequest, commonSaga.getTermsOfService),

        // review saga
        takeLatest(reviewConstants.getSchoolByRatingsRequest, reviewSaga.getSchoolByRatings),
        takeLatest(reviewConstants.listReviewsRequest, reviewSaga.listReviews),
        takeLatest(reviewConstants.getInstructorRatingsRequest, reviewSaga.getInstructorRatings),
        takeLatest(reviewConstants.getSchoolRatingsRequest, reviewSaga.getSchoolRatings),
        takeLatest(reviewConstants.deleteReviewRequest, reviewSaga.deleteReview),
        takeLatest(reviewConstants.viewReviewRequest, reviewSaga.viewReview),
    ]);
} export default rootSaga;
